module.exports = __webpack_public_path__ + "static/media/hongkong_pack.360a69ee.png";